import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const firebaseConfig = {
  apiKey: "AIzaSyAVFqafQQwTv8sJF9lW7JLqdaRtTPZ-x48",
  authDomain: "amazingticket.firebaseapp.com",
  projectId: "amazingticket",
  storageBucket: "amazingticket.appspot.com",
  messagingSenderId: "882071102457",
  appId: "1:882071102457:web:28f28d329e02b682c6d328",
  measurementId: "G-4WQL2Z4TD6",
};

export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);
